import { createContext, useContext } from 'react';

export interface AppContextValue {
    setAdmin: (admin: boolean) => void;
    setSuper: (isSuper: boolean) => void;
    setBroker: (isBroker: boolean) => void;
    setUserId: (userId: string) => void;
    updateAuthentication: (authenticated: boolean, callback?: () => void) => void;
    refreshBroker: () => void;
    bfiUser: any;
}

export const AppContext = createContext<AppContextValue | null>(null);

export const useAppContext = (): AppContextValue => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within an AppContext.Provider');
    }
    return context;
};
